import apiurl from './apiurl';
const axios = require('axios');

const getAnydesk = async (idToken, tenant_id, device_id) => {
    try {
        const result = await axios.get(apiurl + "getAnydesk", {
            'headers': {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + idToken
            },
            'params': {
                tenant_id,
                device_id
            },
            'crossdomain': true,
        });
        return result;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export default getAnydesk;
